import * as React from 'react';
import { RouteComponentProps, Link } from 'react-router-dom';
import { fetchApi } from '../../services/api';

export default function schoolBreadcrumb<T extends RouteComponentProps>(WrappedComponent: React.ComponentType<T>, options = {}) {

    type State = {
        schoolName: string;
    }

    type Props = RouteComponentProps<{ schoolId: string }>;

    return class extends React.Component<Props, State> {

        constructor(props: Props) {
            super(props);

            this.state = {
                schoolName: ''
            }

            this.fetchFacilityName = this.fetchFacilityName.bind(this);
        }

        componentDidMount() {
            this.fetchFacilityName(parseInt(this.props.match.params.schoolId));
        }

        componentWillReceiveProps(nextProps: Props) {
            const currentPage = this.props.location.pathname;
            const nextPage = nextProps.location.pathname;

            if (currentPage !== nextPage) {
                this.fetchFacilityName(parseInt(nextProps.match.params.schoolId));
            }
        }

        render() {
            return <React.Fragment>
                <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to='/schools'>Schools</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">{this.state.schoolName}</li>
                </ol>
                </nav>
                <WrappedComponent {...(this.props as T)} />
            </React.Fragment>
            ;
        }

        private fetchFacilityName(schoolId: number) {
            if (schoolId == 0) {
                this.setState({ schoolName: "New School" })
            } else {
                fetchApi(`/api/Breadcrumb/School/${schoolId}`)
                    .then((schoolName) => this.setState({ schoolName }))
            }
        };
    };
}
